import { NS_PER_MS_BIGINT, nanoSecToDate } from "./time";

/**
 * Converts a JS Date to bigint nanoseconds (millisecond precision).
 */
export function dateToNanosecEpoch(date: Date): bigint {
  return BigInt(date.getTime()) * NS_PER_MS_BIGINT;
}

/**
 * Converts bigint nanoseconds to a JS Date (loses sub-ms precision).
 */
export function nanosecEpochToDate(ns: bigint): Date {
  return nanoSecToDate(ns);
}

/**
 * Converts a JS Date to a nanosecond epoch string for filter persistence.
 *
 * Note: Date has millisecond precision, so the result always ends in
 * six trailing zeros (e.g., `"1710266268000000000"`). Sub-millisecond
 * precision is lost in the round-trip.
 */
export function dateToNanosecString(date: Date): string {
  return dateToNanosecEpoch(date).toString();
}

/**
 * Parses a nanosecond epoch string back to a Date.
 * Returns null if the string is not a valid bigint.
 */
export function nanosecStringToDate(value: string): Date | null {
  if (value === "") {
    return null;
  }
  try {
    return nanosecEpochToDate(BigInt(value));
  } catch {
    return null;
  }
}
